import { render, staticRenderFns } from "./Chongzhi.vue?vue&type=template&id=56d07da6&scoped=true"
import script from "./Chongzhi.vue?vue&type=script&lang=js"
export * from "./Chongzhi.vue?vue&type=script&lang=js"
import style0 from "./Chongzhi.vue?vue&type=style&index=0&id=56d07da6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d07da6",
  null
  
)

export default component.exports